import React, { useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { UserAuth } from "../../utils/AuthContext";
import { SectionContainer, ContentContainer, Button, Tag, Title, Subtitle, BackgroundImage } from "./PageSection.styled";
import { Card } from "@material-ui/core";
import { Flex } from "../styles/Flex.styled";

const useLocalStorage = (storageKey, fallbackState) => {
  const [value, setValue] = React.useState(
    JSON.parse(localStorage.getItem(storageKey)) ?? fallbackState
  );

  React.useEffect(() => {
    localStorage.setItem(storageKey, JSON.stringify(value));
  }, [value, storageKey]);

  return [value, setValue];
};


export const PageSection = ({
  title,
  boldTitle,
  subtitle,
  tag,
  image,
  boldFirst,
  centeredText,
  button1,
  button2
}) => {
  const [role, setRole] = useLocalStorage('profile', '');

  const { googleSignIn } = UserAuth();
  const navigate = useNavigate();  

  const handleGoogleSignInWithRaider = async () => {
    try {
      setRole("raiders");
      await googleSignIn();
      // console.log(res);      
    } catch (error) {
      console.log(error);
      navigate("/");
    }
  };

  const handleGoogleSignInWithWatcher = async () => {
    try {
      setRole("watchers");
      await googleSignIn();
    } catch (error) {
      console.log(error);
      navigate("/");
    }
  };

  useEffect(() => {
    if (role != null) {
      console.log("Profile:", JSON.parse(localStorage.getItem('profile')));
    }
  }, [role]);



  return (
    <SectionContainer>
      <BackgroundImage src={image} />      
      <Flex>
        <ContentContainer centeredText={centeredText}>
          <Card style={{ color: '#fff', backgroundColor: '#000', padding: '2em' }}>
            {tag && <Tag>{tag}</Tag>}
            <Title>
              {boldFirst ? (
                <>
                  <b>{boldFirst}</b>
                  {title}
                </>
              ) : (
                <>
                  {title}
                  <b>{boldTitle}</b>
                </>
              )}
            </Title>

            <Subtitle>{subtitle}</Subtitle>
            <div>
              {centeredText ? (
                <div style={{ marginTop: '2em' }}>
                  <Flex>
                    <Button id="raidderSignin" onClick={handleGoogleSignInWithRaider}>{button1}</Button>
                    <Button id="watcherSignin" onClick={handleGoogleSignInWithWatcher}>{button2}</Button>
                  </Flex>
                </div>
              ) : (
                <span></span>
              )}
            </div>
          </Card>
        </ContentContainer>
      </Flex>
    </SectionContainer>
  );
}